var _attrs;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import namespaces from 'svg-baker/namespaces';
var svg = namespaces.svg,
    xlink = namespaces.xlink;
export default {
  attrs: (_attrs = {}, _defineProperty(_attrs, svg.name, svg.uri), _defineProperty(_attrs, xlink.name, xlink.uri), _defineProperty(_attrs, "style", ['position: absolute', 'width: 0', 'height: 0'].join('; ')), _defineProperty(_attrs, 'aria-hidden', 'true'), _attrs)
};